
import React from 'react';
import classNames from 'classnames';

/**
 * Creates or clones a React component and merges additional props.
 * @param {React.ElementType | React.ReactElement} Icon - Component or element to patch.
 * @param {object} props - Additional props to merge.
 * @returns {React.ReactElement | null} Patched React element.
 */
export default function patchIcon(Icon, props = {}) {
  if (React.isValidElement(Icon)) {
    // Merge className from original and new props
    const patchedProps = {
      ...props,
      className: classNames(Icon.props.className, props.className),
    };
    return React.cloneElement(Icon, patchedProps);
  }

  if (typeof Icon === 'function') {
    const Comp = Icon;
    return <Comp {...props} />;
  }

  return null;
}
